module.exports = __webpack_public_path__ + "img/keyv_mob_3.4012bc65.jpg";